import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeIcon, ConstructionIcon } from 'lucide-react';
const WorkInProgress: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-id="element-2187">
      <div className="bg-white rounded-xl shadow-sm p-8 max-w-md w-full text-center" data-id="element-2188">
        <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2189">
          <ConstructionIcon size={32} className="text-purple-600" data-id="element-2190" />
        </div>
        <h1 className="text-2xl font-bold mb-2" data-id="element-2191">Feature Coming Soon</h1>
        <p className="text-gray-600 mb-6" data-id="element-2192">
          We're working hard to bring you this feature. Check back soon!
        </p>
        <button onClick={() => navigate('/')} className="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center justify-center mx-auto" data-id="element-2193">
          <HomeIcon size={18} className="mr-2" data-id="element-2194" />
          Return Home
        </button>
      </div>
    </div>;
};
export default WorkInProgress;